import React, { useState } from "react";
import { Link } from "react-router-dom";
import musicData from "../musicData";
import SongPlayer from "../components/SongPlayer";
import "../styles/Music.css";

const MusicPage = () => {
  const [selectedSong, setSelectedSong] = useState(null);

  return (
    <div className="music-page">
      {/* Header */}
      <div className="music-header">
        <Link to="/" className="music-back-btn">
          ← Portfolio
        </Link>
        {selectedSong ? (
          <button
            className="music-back-btn"
            onClick={() => setSelectedSong(null)}
          >
            ← All Songs
          </button>
        ) : null}
        {!selectedSong && (
          <h1 className="music-page-title">Discography</h1>
        )}
      </div>

      {/* Gallery or Player */}
      {selectedSong ? (
        <SongPlayer
          song={selectedSong}
          onBack={() => setSelectedSong(null)}
        />
      ) : (
        <div className="music-gallery">
          {musicData.map((song) => (
            <div
              key={song.id}
              className="song-card"
              onClick={() => setSelectedSong(song)}
            >
              <div className="song-card-artwork-wrap">
                <img
                  src={song.artworkUrl}
                  alt={song.title}
                  className="song-card-artwork"
                  loading="lazy"
                />
                {song.hasKaraoke && (
                  <div className="song-card-karaoke-badge" title="Karaoke version available">
                    <svg viewBox="0 0 24 24" width="12" height="12" fill="currentColor">
                      <path d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm-1-9c0-.55.45-1 1-1s1 .45 1 1v6c0 .55-.45 1-1 1s-1-.45-1-1V5z"/>
                      <path d="M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z"/>
                    </svg>
                  </div>
                )}
                <div className="song-card-overlay">
                  <div className="song-card-play-icon">
                    <svg viewBox="0 0 24 24">
                      <path d="M8 5v14l11-7z" />
                    </svg>
                  </div>
                </div>
              </div>
              <div className="song-card-info">
                <div className="song-card-title">{song.title}</div>
                <div className="song-card-duration">{song.duration}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MusicPage;
